import { Howler } from 'howler'
import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

interface GameSettingsState {
  animationsEnabled: boolean
  hotkeysEnabled: boolean
  instantBetEnabled: boolean
  maxBetEnabled: boolean
  soundsEnabled: boolean
  soundsVolume: number
  toggleAnimations: () => void
  toggleInstantBet: () => void
  toggleMaxBet: () => void
  toggleSounds: () => void
  setSoundsVolume: (volume: number) => void
}

const useGameSettings = create<GameSettingsState>()(
  persist(
    (set, get) => ({
      animationsEnabled: true,
      hotkeysEnabled: false,
      instantBetEnabled: false,
      maxBetEnabled: false,
      soundsEnabled: true,
      soundsVolume: 1,
      toggleAnimations: () =>
        set(() => ({ animationsEnabled: !get().animationsEnabled })),
      toggleInstantBet: () =>
        set(() => ({ instantBetEnabled: !get().instantBetEnabled })),
      toggleMaxBet: () => set(() => ({ maxBetEnabled: !get().maxBetEnabled })),
      toggleSounds: () => {
        Howler.mute(get().soundsEnabled)
        set(() => ({ soundsEnabled: !get().soundsEnabled }))
      },
      setSoundsVolume: (volume) => {
        Howler.mute(false)
        Howler.volume(volume)
        set({ soundsEnabled: true, soundsVolume: volume })
      },
    }),
    {
      name: 'settings',
      storage: createJSONStorage(() => localStorage),
      onRehydrateStorage: (state) => {
        return (state, error) => {
          if (state) {
            Howler.volume(state.soundsVolume)
            Howler.mute(!state.soundsEnabled)
          }
        }
      },
    }
  )
)

export default useGameSettings
